(function ($) {
  $(document).ready(function(){

    $('div.hero__preview__info__duration div').attr('id', 'firstWord');

    $("#firstWord").html(function(){
      var text= $(this).text().trim().split(" ");
      var first = text.shift();
      return (text.length > 0 ? "<span class='big'>"+ first + "</span> " : first) + text.join(" ");
    });

  });
})(jQuery);
